import React from 'react';

// import { images } from '../../constants';

const SubHeading = ({ title }) => (
  <div style={{ marginBottom: '1rem' }}>
    <p className="p__cormorant">{title}</p>
    <hr style={{ width: '35%', height: '1px', backgroundColor: 'rgb(232 183 3)' }} />
  </div>
);

export default SubHeading;
